var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"shimmer-button",on:{"click":function($event){$event.preventDefault();return _vm.$root.$emit('openGlobalSearch')}}},[_c('feather-icon',{attrs:{"icon":"SearchIcon","size":"16"}}),_c('span',[_vm._v(" Search")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }